import React from "react";
import Carousel from "react-multi-carousel";
import useWindowDimensions from "../../common/hooks/useWindowDimensions";

interface IDapCarouselProps {
    showArrows?: boolean;
    centerMode?: boolean;
    infinite?: boolean;
    itemClass?: string;
    maxItem?: number;
    isMini?: boolean;
}

const DapCarousel: React.FC<IDapCarouselProps> = (props) => {
    const {
        showArrows,
        centerMode,
        infinite,
        itemClass,
        maxItem,
        children,
        isMini
    } = props;
    const { isTabletPortrait } = useWindowDimensions();

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: isMini ? 3 : maxItem ? maxItem : 3
        },
        tablet: {
            breakpoint: { max: 1024, min: 768 },
            items: isMini ? 3 : maxItem < 3 ? maxItem : 2,
            partialVisibilityGutter: 40
        },
        mobile: {
            breakpoint: { max: 768, min: 0 },
            items: 1,
            partialVisibilityGutter: 40
        }
    };

    return (
        <React.Fragment>
            <Carousel
                arrows={showArrows ? isTabletPortrait : false}
                centerMode={centerMode || false}
                infinite={infinite || false}
                keyBoardControl
                minimumTouchDrag={80}
                responsive={responsive}
                slidesToSlide={1}
                swipeable={isTabletPortrait}
                draggable={isTabletPortrait}
                itemClass={itemClass}>
                {children}
            </Carousel>
        </React.Fragment>
    );
};

export default DapCarousel;
